import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

interface PropsType {
    className?: string;
    onClick?: () => void;
}

export const PlanetSportBrandIcon = observer(
    'PlanetSportBrandIcon',
    ({ className, onClick }: PropsType): JSX.Element => (
        <SvgElement
            className={className}
            onClick={onClick}
            fill='none'
            width='32'
            height='32'
            viewBox='0 0 32 32'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M15.3333 2.66666C22.6971 2.66666 28.6667 8.63619 28.6667 16C28.6667 23.3638 22.6971 29.3333 15.3333 29.3333C7.96954 29.3333 2 23.3638 2 16C2 8.63619 7.96954 2.66666 15.3333 2.66666ZM15.3333 4.73103C9.10966 4.73103 4.06437 9.77631 4.06437 16C4.06437 22.2237 9.10966 27.269 15.3333 27.269C21.557 27.269 26.6023 22.2237 26.6023 16C26.6023 9.77631 21.557 4.73103 15.3333 4.73103ZM20.0577 10.8138L21.7629 13.0404L20.8951 16.8178L18.5504 18.7219H13.2522L12.482 21.5627H9.62863L11.7565 12.2893L9.62708 10.8138H20.0577ZM18.1606 13.2943H14.4253L13.7643 16.1883H17.4381L18.1606 15.5974L18.591 13.8246L18.1606 13.2943Z'
                fill='#EC004F'
            />
        </SvgElement>
    )
);
